import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "comment" }
const _hoisted_2 = { class: "icon-wrapper" }
const _hoisted_3 = { class: "material-icons icon" }
const _hoisted_4 = { class: "comment-date" }
const _hoisted_5 = { class: "comment-time" }
const _hoisted_6 = { class: "comment-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.icon), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.comment.DateCreated.toLocaleDateString("da-DK")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.comment.DateCreated.toLocaleTimeString("da-DK", { hour: "numeric", minute: "numeric" })), 1 /* TEXT */)
    ]),
    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.comment.Text), 1 /* TEXT */)
  ]))
}